import { computed, toValue } from 'vue';

export default function useRuleSetResults(ruleSetResult) {
  const results = computed(() => toValue(ruleSetResult)?.results || []);

  const failedResults = computed(() => {
    return results.value.filter((ruleResult) => !ruleResult.passes);
  });

  const sortedResults = computed(() => {
    // Sort failed results first, then passed results
    return results.value.sort((current, next) =>
      current.passes === next.passes ? 0 : current.passes ? 1 : -1,
    );
  });

  const hasResults = computed(() => {
    return results.value.length > 0;
  });

  const hasFailedResults = computed(() => {
    return failedResults.value.length > 0;
  });

  const evaluatedAt = computed(() => {
    return toValue(ruleSetResult)?.evaluatedAt || null;
  });

  return {
    failedResults,
    sortedResults,
    hasResults,
    hasFailedResults,
    evaluatedAt,
  };
}
